/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_ResendingInputs */

const he_auth_otp_resending = /** @type {(inputs: Auth_Otp_ResendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולח מחדש...`)
};

const en_auth_otp_resending = /** @type {(inputs: Auth_Otp_ResendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resending...`)
};

/**
* | output |
* | --- |
* | "Resending..." |
*
* @param {Auth_Otp_ResendingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_resending = /** @type {((inputs?: Auth_Otp_ResendingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_ResendingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_resending(inputs)
	return en_auth_otp_resending(inputs)
});